import { View, type ViewProps } from 'react-native';
import { twMerge } from 'tailwind-merge';
import { useIsDesktop } from '../hooks/useIsDesktop';

interface PageContainerProps extends ViewProps {
  children: React.ReactNode;
  className?: string;
  /** Max-width variant. 'default' = 960px, 'wide' = 1200px, 'narrow' = 640px */
  size?: 'narrow' | 'default' | 'wide';
}

const SIZE_CLASSES = {
  narrow: 'max-w-[640px]',
  default: 'max-w-[960px]',
  wide: 'max-w-[1200px]',
} as const;

/**
 * Constrains content width on desktop web (>= 768px) for readable line lengths.
 * On mobile or narrow web viewports, renders children in a full-width View.
 */
export function PageContainer({
  children,
  className = '',
  size = 'default',
  ...rest
}: PageContainerProps) {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return (
      <View className={className} {...rest}>
        {children}
      </View>
    );
  }

  return (
    <View className={twMerge('w-full mx-auto px-8 py-6', SIZE_CLASSES[size], className)} {...rest}>
      {children}
    </View>
  );
}
